<div *ngIf="!loading && !employee && !!contractId" class="padding">
  <gp-message text="FORMS.ERRORS.employee_error" type="danger"></gp-message>
</div>
<div *ngIf="!loading && contracts?.length == 0" class="padding">
  <gp-message text="EMPLOYEE_FORM.no_contract_found_for_employee" type="info"></gp-message>
</div>

<div *ngIf="loading" class="padding">
  <div class="flex">
    <skeleton-avatar [size]="100" [effect]="'wave'"></skeleton-avatar>
    <div class="flex-1 flex flex-column m-l-md">
      <skeleton-block width="30%" height="30px" [effect]="'wave'" borderRadius="4"></skeleton-block>
      <skeleton-block class="m-t-sm" width="40%" height="30px" [effect]="'wave'" borderRadius="4"></skeleton-block>
      <skeleton-block class="m-t-sm" width="40%" height="30px" [effect]="'wave'" borderRadius="4"></skeleton-block>
    </div>
  </div>
</div>

<div *ngIf="!loading && !!employee" [gp-loading]="saving">

  <div class="top-header" [class.top-header--sticky]="sticky && !isModalOpened">
    <div class="top-card">
      <div class="employee-bloc">
        <div class="avatar">
          <div (click)="showImageCropper()">
            <gp-user-avatar [pictureUri]="employee?.photoLink?.href"
                            [initials]="getInitials()"
                            size="lg"
                            [classes]="(isSkillModule || readOnly || isPeopleRead) ? '' : 'pointer hover-plus'">
            </gp-user-avatar>
            <div class="status"
                 [ngClass]="{
                    'active': employee?.userActive,
                    'inactive': !employee?.userActive
                    }"
                 [tooltip]="employee?.userActive ? ('EMPLOYEE_FORM.user_active' | translate) :
                 employee?.userActive === false ? ('EMPLOYEE_FORM.user_inactive' | translate) :
                     ('EMPLOYEE_FORM.user_not_created' | translate)">
              <div class="icon">
                <em class="fa" [ngClass]="{
                    'fa-check': employee?.userActive,
                    'fa-exclamation': !employee?.userActive
                    }"></em>
              </div>

            </div>
          </div>
        </div>
        <div class="employee-info-wrapper">
          <div class="employee-info">
            <div>
              <h5>
                <span class="break-word" [class.non-active]="employee?.isInactive">{{ employee?.firstName }} <span
                  class="font-weight-bold">{{ employee?.lastName }}</span></span>
              </h5>
            </div>
            <div class="email" *ngIf="employee.email">
              <em class="fa fa-light fa-envelope"></em>
              {{ employee.email }}
              <em (click)="copyEmailToClipboard($event)"
                  *ngIf="!isCopied"
                  class="fa fa-light fa-copy pointer"
                  tooltip="{{'EMPLOYEE_FORM.copy_email' | translate}}"></em>
              <em (mouseout)="toggleTooltip($event,false)"
                  *ngIf="isCopied"
                  triggers="mouseenter:mouseleave"
                  class="fas fa-light fa-copy pointer"
                  tooltip="{{'WORKFLOWS.copied' | translate}}"></em></div>
            <gp-display-employee-id [employee]="employee"></gp-display-employee-id>
          </div>
          <div class="employee-extra-info" *ngIf="employeePosition || employeeLocation || employeeBusinessUnit">
            <div class="extra-info-item" *ngIf="employeePosition">
              <em class="fa fa-light fa-briefcase"></em>
              <span>{{ employeePosition | translate }}</span>
            </div>
            <div class="extra-info-item" *ngIf="employeeLocation">
              <em class="fa fa-light fa-location-dot"></em>
              <span>{{ employeeLocation | translate }}</span>
            </div>
            <div class="extra-info-item" *ngIf="employeeBusinessUnit">
              <em class="fa fa-light fa-building"></em>
              <span>{{ employeeBusinessUnit | translate }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="contract-bloc">
        <div class="contract-top" *ngIf="!isSkillModule">
          <gp-sdc-statuses [sdcStatus]="selectedContractSdcStatus"
                         [contract]="selectedContract">
          </gp-sdc-statuses>
          <gp-employee-menu [employeeId]="employee?.id"
                            [cliRegId]="cliRegId"
                            [contractId]="selectedContract?.id"
                            [readOnly]="readOnly"
                            [hiddenItems]="{modify: true}"
                            [contract]="selectedContract"
                            [sdcStatus]="selectedContractSdcStatus"
                            [employee]="employee"
                            [contracts]="contracts"
                            (updatedEmployee)="employee = $event"
                            (contractUpdated)="reloadEmployeeAndContractsData()"
          ></gp-employee-menu>
        </div>
        <div class="contract-actions">
          <gp-contract-switcher
            [selectedContract]="selectedContract"
            [contracts]="contracts"
            (onSelectContract)="selectContract($event)">
          </gp-contract-switcher>
        </div>

      </div>

    </div>

    <div class="btn-bar-wrapper" *ngIf="(!readOnly && !isPeopleRead) || !isVariableReadOnly || !isTimeReadOnly">
      <div class="btn-bar btn-bar-sm btn-bar-align-end" *ngIf="!formIsPristine">
        <button type="button" tooltip="{{ 'TOOLTIPS.mass_data_update' | translate }}" placement="bottom"
                class="btn btn-xs btn-outline-primary circle" style="line-height: 2.3 !important;"
                *ngIf="initialTab === 'Variable payroll' || initialTab === 'Time & attendance'"
                (click)="massUpdateMode()">
          <em class="fa-light fa-users"></em>
        </button>
        <button type="button" class="btn btn-sm btn-secondary p-x-md"
                [disabled]="formIsPristine || isActionButtonDisabled"
                test-id="cancelChangesBtn"
                (click)="confirmResetForm()">
          {{ 'FORMS.cancel' | translate }}
        </button>
        <button type="button" class="btn btn-sm btn-primary p-x-md"
                [disabled]="formIsPristine || isActionButtonDisabled"
                test-id="saveChangesBtn"
                (click)="updateEmployeeAndContract()">
          {{ 'FORMS.save_changes' | translate }}
        </button>
      </div>
    </div>

  </div>

  <div *ngIf="loadingForm" class="p-x-sm">
    <p>
      <skeleton-block width="100%" height="30px" [effect]="'wave'" borderRadius="4"></skeleton-block>
    </p>
    <div class="m-t-sm flex">
      <skeleton-block width="50%" height="300px" [effect]="'wave'" borderRadius="4"></skeleton-block>
      <skeleton-block class="m-l-md" width="50%" height="300px" [effect]="'wave'" borderRadius="4"></skeleton-block>
    </div>
  </div>
  <div *ngIf="!loadingForm && !selectedContract" class="padding">
    <gp-message text="FORMS.ERRORS.contract_error" type="danger"></gp-message>
  </div>
  <div *ngIf="!loadingForm && isSkillModule && formDescriptor.tabSheets.length === 0" class="p-y-lg">
    <gp-illustrated-message [text]="'TABS.skills_not_found'" [width]="'65%'"></gp-illustrated-message>
  </div>

  <div class="employee-content-wrapper"
       [class.has-action-bar]="!formIsPristine"
       *ngIf="formDescriptor && !loadingForm && selectedContract">
    <div class="vertical-sidebar" *ngIf="selectedContract?.id && !isSkillModule" data-tour="emp-sidebar">
      <!-- Contract Details -->
      <button type="button"
              class="sidebar-btn"
              test-id="sidebar-contract-details"
              *ngIf="hasContractTabs"
              data-tour="emp-contract-details"
              [ngClass]="{'sidebar-btn--active': !isInlinePanelOpen && activeSidebarView === 'contract'}"
              [tooltip]="'EMPLOYEE_FORM.contract_details' | translate"
              placement="right" [adaptivePosition]="false" container="body" containerClass="sidebar-tooltip"
              triggers="mouseenter:mouseleave"
              (click)="showContractDetailsPanel()">
        <em class="fa fa-light fa-file-contract"></em>
        <span class="sidebar-btn__badge" *ngIf="hasContractTabError">
          <em class="fa fa-solid fa-exclamation"></em>
        </span>
      </button>
      <!-- Employee Details -->
      <button type="button"
              class="sidebar-btn"
              test-id="sidebar-employee-details"
              *ngIf="hasEmployeeTabs"
              data-tour="emp-employee-details"
              [ngClass]="{'sidebar-btn--active': !isInlinePanelOpen && activeSidebarView === 'employee'}"
              [tooltip]="'EMPLOYEE_FORM.employee_details' | translate"
              placement="right" [adaptivePosition]="false" container="body" containerClass="sidebar-tooltip"
              triggers="mouseenter:mouseleave"
              (click)="showEmployeeDetailsPanel()">
        <em class="fa fa-light fa-user"></em>
        <span class="sidebar-btn__badge" *ngIf="hasEmployeeTabError">
          <em class="fa fa-solid fa-exclamation"></em>
        </span>
      </button>
      <!-- Fallback Data button when no typed tabs exist -->
      <button type="button"
              class="sidebar-btn"
              test-id="sidebar-data"
              *ngIf="!hasEmployeeTabs && !hasContractTabs"
              [ngClass]="{'sidebar-btn--active': !isInlinePanelOpen}"
              [tooltip]="'EMPLOYEE_FORM.contract_details' | translate"
              placement="right" [adaptivePosition]="false" container="body" containerClass="sidebar-tooltip"
              triggers="mouseenter:mouseleave"
              (click)="showDataPanel()">
        <em class="fa fa-light fa-file-contract"></em>
      </button>
      <!-- Documents -->
      <button type="button"
              class="sidebar-btn"
              test-id="sidebar-documents"
              data-tour="emp-special-panels"
              data-tour-group="emp-quick-access"
              [ngClass]="{'sidebar-btn--active': isInlinePanelOpen && activeInlinePanel === INLINE_PANEL.DOCUMENTS}"
              [tooltip]="'DOCUMENTS.employee_documents' | translate"
              placement="right" [adaptivePosition]="false" container="body" containerClass="sidebar-tooltip"
              triggers="mouseenter:mouseleave"
              gp-roles
              [userRoles]="['PEOPLE_DOCUMENTS']"
              (click)="openInlinePanel(INLINE_PANEL.DOCUMENTS)">
        <em class="fa fa-light fa-file-lines"></em>
      </button>
      <!-- Attachments -->
      <button type="button"
              class="sidebar-btn"
              test-id="sidebar-attachments"
              data-tour-group="emp-quick-access"
              [ngClass]="{'sidebar-btn--active': isInlinePanelOpen && activeInlinePanel === INLINE_PANEL.ATTACHMENTS}"
              [tooltip]="'EMPLOYEE_MANAGE.attachments' | translate"
              placement="right" [adaptivePosition]="false" container="body" containerClass="sidebar-tooltip"
              triggers="mouseenter:mouseleave"
              gp-roles
              [userRoles]="['FILE_VIEWER']"
              *ngIf="hasAttachmentPanel"
              (click)="openInlinePanel(INLINE_PANEL.ATTACHMENTS)">
        <em class="fa fa-light fa-paperclip"></em>
      </button>
      <!-- HR Calendar -->
      <button type="button"
              class="sidebar-btn"
              test-id="sidebar-hr-calendar"
              data-tour-group="emp-quick-access"
              [ngClass]="{'sidebar-btn--active': isInlinePanelOpen && activeInlinePanel === INLINE_PANEL.HR_CALENDAR}"
              [tooltip]="'HR_CALENDAR.hr_calendar' | translate"
              [attr.aria-label]="'HR_CALENDAR.hr_calendar' | translate"
              [attr.aria-pressed]="isInlinePanelOpen && activeInlinePanel === INLINE_PANEL.HR_CALENDAR"
              placement="right" [adaptivePosition]="false" container="body" containerClass="sidebar-tooltip"
              triggers="mouseenter:mouseleave focus:blur"
              gp-roles
              [userRoles]="['HR_CALENDAR']"
              *ngIf="hrCalendarEnabled"
              (click)="openInlinePanel(INLINE_PANEL.HR_CALENDAR)">
        <em class="fa fa-light fa-calendar-days" aria-hidden="true"></em>
      </button>
      <!-- Change Tracking -->
      <button type="button"
              class="sidebar-btn"
              test-id="sidebar-change-tracking"
              data-tour-group="emp-quick-access"
              [ngClass]="{'sidebar-btn--active': isInlinePanelOpen && activeInlinePanel === INLINE_PANEL.CHANGE_TRACKING}"
              [tooltip]="'CHANGE_TRACKING.change_tracking' | translate"
              placement="right" [adaptivePosition]="false" container="body" containerClass="sidebar-tooltip"
              triggers="mouseenter:mouseleave"
              gp-roles
              [userRoles]="['PEOPLE_READ', 'PEOPLE_WRITE']"
              (click)="openInlinePanel(INLINE_PANEL.CHANGE_TRACKING)">
        <em class="fa fa-light fa-clock-rotate-left"></em>
      </button>
      <!-- Event Logs -->
      <button type="button"
              class="sidebar-btn"
              test-id="sidebar-event-logs"
              data-tour-group="emp-quick-access"
              [ngClass]="{'sidebar-btn--active': isInlinePanelOpen && activeInlinePanel === INLINE_PANEL.EVENTS_LOG}"
              [tooltip]="'EVENT_LOG.events_log' | translate"
              placement="right" [adaptivePosition]="false" container="body" containerClass="sidebar-tooltip"
              triggers="mouseenter:mouseleave"
              gp-roles
              [userRoles]="['ADMIN', 'EVENT_VIEWER']"
              (click)="openInlinePanel(INLINE_PANEL.EVENTS_LOG)">
        <em class="fa fa-light fa-list-timeline"></em>
        <span class="sidebar-btn__badge" *ngIf="hasEventErrors">
          <em class="fa fa-solid fa-exclamation"></em>
        </span>
      </button>
      <!-- Person Master Data Admin -->
      <button type="button"
              class="sidebar-btn"
              test-id="sidebar-person-master-data-admin"
              data-tour-group="emp-quick-access"
              [ngClass]="{'sidebar-btn--active': isInlinePanelOpen && activeInlinePanel === INLINE_PANEL.PERSON_MASTER_DATA_ADMIN}"
              tooltip="Person Master Data Admin"
              placement="right" [adaptivePosition]="false" container="body" containerClass="sidebar-tooltip"
              triggers="mouseenter:mouseleave"
              gp-roles
              [userRoles]="['SDCONNECT_ADMIN', 'SDC3_ADMIN']"
              *ngIf="sdConnectEnabled"
              (click)="openInlinePanel(INLINE_PANEL.PERSON_MASTER_DATA_ADMIN)">
        <em class="fa fa-light fa-wrench"></em>
        <span class="sidebar-btn__badge__bottom-text">
          <span>PMD</span>
        </span>
      </button>
      <!-- Payroll Input Admin -->
      <button type="button"
              class="sidebar-btn"
              test-id="sidebar-payroll-input-admin"
              data-tour-group="emp-quick-access"
              [ngClass]="{'sidebar-btn--active': isInlinePanelOpen && activeInlinePanel === INLINE_PANEL.PAYROLL_INPUT_ADMIN}"
              tooltip="Payroll Input Admin"
              placement="right" [adaptivePosition]="false" container="body" containerClass="sidebar-tooltip"
              triggers="mouseenter:mouseleave"
              gp-roles
              [userRoles]="['SDC3_ADMIN']"
              *ngIf="sdConnectEnabled"
              (click)="openInlinePanel(INLINE_PANEL.PAYROLL_INPUT_ADMIN)">
        <em class="fa fa-light fa-wrench"></em>
        <span class="sidebar-btn__badge__bottom-text">
          <span>PI</span>
        </span>
      </button>
      <!-- SDC Person Form -->
      <button type="button"
              class="sidebar-btn"
              test-id="sidebar-sdc-person"
              data-tour-group="emp-quick-access"
              [ngClass]="{'sidebar-btn--active': isInlinePanelOpen && activeInlinePanel === INLINE_PANEL.SDC_PERSON}"
              [tooltip]="'SDC.sdc_person_form' | translate"
              placement="right" [adaptivePosition]="false" container="body" containerClass="sidebar-tooltip"
              triggers="mouseenter:mouseleave"
              *ngIf="sdcPersonEnabled"
              (click)="openInlinePanel(INLINE_PANEL.SDC_PERSON)">
        <em class="fa fa-light fa-user-gear"></em>
      </button>
      <!-- SDC Payroll Form -->
      <button type="button"
              class="sidebar-btn"
              test-id="sidebar-sdc-payroll"
              data-tour-group="emp-quick-access"
              [ngClass]="{'sidebar-btn--active': isInlinePanelOpen && activeInlinePanel === INLINE_PANEL.SDC_PAYROLL}"
              [tooltip]="'SDC.sdc_payroll_form' | translate"
              placement="right" [adaptivePosition]="false" container="body" containerClass="sidebar-tooltip"
              triggers="mouseenter:mouseleave"
              *ngIf="sdcPayrollEnabled"
              (click)="openInlinePanel(INLINE_PANEL.SDC_PAYROLL)">
        <em class="fa fa-light fa-hand-holding-dollar"></em>
      </button>
      <!-- Time -->
      <button type="button"
              class="sidebar-btn"
              test-id="sidebar-time"
              data-tour-group="emp-quick-access"
              [ngClass]="{'sidebar-btn--active': isInlinePanelOpen && activeInlinePanel === INLINE_PANEL.TIME}"
              [tooltip]="'PAYROLL_PREPARE.time_attendance' | translate"
              placement="right" [adaptivePosition]="false" container="body" containerClass="sidebar-tooltip"
              triggers="mouseenter:mouseleave"
              gp-roles
              [userRoles]="['ABSENCE_PEOPLE_READ', 'ABSENCE_PEOPLE_WRITE']"
              (click)="openInlinePanel(INLINE_PANEL.TIME)">
        <em class="fa fa-light fa-calendar-days"></em>
      </button>
      <!-- Payslips -->
      <button type="button"
              class="sidebar-btn"
              test-id="sidebar-payslips"
              data-tour-group="emp-quick-access"
              [ngClass]="{'sidebar-btn--active': isInlinePanelOpen && activeInlinePanel === INLINE_PANEL.PAYSLIPS}"
              [tooltip]="'EMPLOYEE_MANAGE.payslips' | translate"
              placement="right" [adaptivePosition]="false" container="body" containerClass="sidebar-tooltip"
              triggers="mouseenter:mouseleave"
              gp-roles
              [userRoles]="['PAYSLIP_PEOPLE']"
              (click)="openInlinePanel(INLINE_PANEL.PAYSLIPS)">
        <em class="fa fa-light fa-file-invoice-dollar"></em>
      </button>
      <!-- Alerts -->
      <button type="button"
              class="sidebar-btn"
              test-id="sidebar-alerts"
              *ngIf="hasContractAlerts"
              data-tour="emp-alerts"
              data-tour-group="emp-quick-access"
              [ngClass]="{'sidebar-btn--active': isInlinePanelOpen && activeInlinePanel === INLINE_PANEL.ALERTS}"
              [tooltip]="'ALERTS.contract_alerts' | translate"
              placement="right" [adaptivePosition]="false" container="body" containerClass="sidebar-tooltip"
              triggers="mouseenter:mouseleave"
              gp-roles
              [userRoles]="['PEOPLE_READ', 'PEOPLE_WRITE']"
              (click)="openInlinePanel(INLINE_PANEL.ALERTS)">
        <em class="fa fa-light fa-triangle-exclamation"></em>
        <span class="sidebar-btn__badge" *ngIf="hasContractAlerts">
          <em class="fa fa-solid fa-exclamation"></em>
        </span>
      </button>
    </div>

    <div #employeeDetailContent
         class="employee-detail-content"
         [class.inline-panel-active]="isInlinePanelOpen"
         [style.height]="isInlinePanelOpen ? inlinePanelHeightPx : null">
      <gp-generated-form
        [class.inline-panel-open]="isInlinePanelOpen"
        [configuration]="formDescriptor"
        [values]="values"
        [initialTab]="initialTab"
        [isSkillModule]="isSkillModule"
        [employee]="employee"
        [hiddenTabIds]="viewFilteredHiddenTabIds"
        [activeCardSubject]="activeCardSubject"
        [readOnly]="readOnly || isPeopleRead"
        (formLoaded)="formLoaded()"
        (tabSelected)="onTabSelected($event)">
      </gp-generated-form>

      <div class="inline-panel" *ngIf="isInlinePanelOpen">
        <div class="inline-panel__header">
          <div class="inline-panel__header-left">
            <h3 class="m-b-0">{{ activeInlinePanelTitleKey | translate }}</h3>
          </div>
        </div>
        <div class="panel-content" [ngSwitch]="activeInlinePanel">
          <gp-documents-list
            *ngSwitchCase="INLINE_PANEL.DOCUMENTS"
            [selectedContract]="selectedContract?.id"
            [employee]="employee"
            [cliRegId]="cliRegId"
            [hideTitle]="true"
            [readonly]="readOnly || selectedContract?.readOnly">
          </gp-documents-list>

          <gp-attachments
            *ngSwitchCase="INLINE_PANEL.ATTACHMENTS"
            [contractId]="selectedContract?.id"
            [empValues]="values"
            [hideTitle]="true"
            [isReadOnly]="readOnly || selectedContract?.readOnly">
          </gp-attachments>

          <gp-hr-calendar
            *ngSwitchCase="INLINE_PANEL.HR_CALENDAR"
            [workSchedules]="hrCalendarWorkSchedules">
          </gp-hr-calendar>

          <gp-change-tracking
            *ngSwitchCase="INLINE_PANEL.CHANGE_TRACKING"
            [hideTitle]="true"
            (init)="onChangeTrackingInit($event)">
          </gp-change-tracking>

          <gp-log-event
            *ngSwitchCase="INLINE_PANEL.EVENTS_LOG"
            [tableOnly]="true">
          </gp-log-event>

          <gp-contract-alerts
            *ngSwitchCase="INLINE_PANEL.ALERTS"
            [tableOnly]="true">
          </gp-contract-alerts>

          <gp-person-master-data-admin
            *ngSwitchCase="INLINE_PANEL.PERSON_MASTER_DATA_ADMIN">
          </gp-person-master-data-admin>

          <gp-payroll-input-admin
            *ngSwitchCase="INLINE_PANEL.PAYROLL_INPUT_ADMIN">
          </gp-payroll-input-admin>

          <gp-sdc-person-form
            #sdcPersonPanel
            *ngSwitchCase="INLINE_PANEL.SDC_PERSON">
          </gp-sdc-person-form>

          <gp-sdc-payroll-form
            #sdcPayrollPanel
            *ngSwitchCase="INLINE_PANEL.SDC_PAYROLL">
          </gp-sdc-payroll-form>

          <gp-pay-slip
            *ngSwitchCase="INLINE_PANEL.PAYSLIPS"
            [contractId]="contractId"
            [hideTitle]="true">
          </gp-pay-slip>

          <gp-payroll-prepare-time-and-attendance
            #timePanel
            *ngSwitchCase="INLINE_PANEL.TIME"
            [contract]="selectedContract"
            [employee]="employee"
            [cliRegId]="selectedContract?.cliRegID"
            [isReadOnly]="isTimeReadOnly">
          </gp-payroll-prepare-time-and-attendance>
        </div>
      </div>
    </div>
  </div>
</div>

<gp-blocking-error-modal
  [blockingErrors]="blockingErrors"
></gp-blocking-error-modal>
